module.exports = __webpack_public_path__ + "img/fushimi-HP-011.c23e92cf.jpg";